import admin from "api/admin/index";
import start from "api/start";


const api = { admin, start };
export default api;